import {
    BrandDTO,
    CompanyTypeDTO,
    CompanyTypes,
    CountryLookupDTO,
    DocumentTypeDTO,
    LookupClient_V1,
    LookupTypeDTO,
    PostalCodeInfoDTO,
    DealerSettingDTO,
    StateLookupDTO,
    TermsAndConditionDTO,
    DynamicsCountryDTO,
    SpiffTypeDTO,
    WarrantyClassCodeDTO,
    WarrantyRemedyCodeDTO,
    WarrantyFailureCodeDTO,
    WarrantyMiscChargeCodeDTO,
    ExportDTO
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import { CatalogBrandDTO, DeliveryModeDTO, ClaimStatusTypeDTO } from './generated/api.generated.v2';

export default class LookupService {
    private readonly _lookupClient: LookupClient_V1;

    constructor() {
        this._lookupClient = new LookupClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public ApplicationRoles(): Promise<Array<LookupTypeDTO>> {
        return this._lookupClient.roles();
    }

    public ApplicationDealerUserRoles(dealerAccountUID: string): Promise<Array<LookupTypeDTO>> {
        return this._lookupClient.dealerUserRoles(dealerAccountUID);
    }

    public ApplicationDealerAdminRoles(): Promise<Array<LookupTypeDTO>> {
        return this._lookupClient.dealerAdminRoles();
    }

    public ApplicationPermissions(): Promise<Array<LookupTypeDTO>> {
        return this._lookupClient.permissions();
    }

    public Brands(): Promise<Array<BrandDTO>> {
        return this._lookupClient.brands();
    }

    public CompanyType(): Promise<CompanyTypeDTO> {
        return this._lookupClient.companyType();
    }

    public Countries(): Promise<Array<CountryLookupDTO>> {
        return this._lookupClient.countries();
    }

    public DocumentTypes(): Promise<Array<DocumentTypeDTO>> {
        return this._lookupClient.documentTypes();
    }

    public Settings(): Promise<DealerSettingDTO> {
        return this._lookupClient.dealerSettings();
    }

    public States(): Promise<Array<StateLookupDTO>> {
        return this._lookupClient.states();
    }

    public TermsAndConditions(companyType : CompanyTypes): Promise<TermsAndConditionDTO> {
        return this._lookupClient.termsAndConditions(companyType);
    }

    public PostalCodeInfo( countryCode : string, postalCode : string) : Promise<Array<PostalCodeInfoDTO>> {
        return this._lookupClient.postalCodeInfo(countryCode, postalCode);
    }

    public DynamicsCountries() : Promise<Array<DynamicsCountryDTO>> {
        return this._lookupClient.dynamicsCountries();
    }

    public SpiffTypes(): Promise<Array<SpiffTypeDTO>> {
        return this._lookupClient.spiffTypes();
    }

    public CatalogBrands(): Promise<Array<CatalogBrandDTO>> {
        return this._lookupClient.catalogBrands();
    }

    public CatalogYearsByBrand(brandId : string): Promise<Array<string>> {
        return this._lookupClient.catalogYearsByBrand(brandId);
    }

    public DeliveryModes(): Promise<Array<DeliveryModeDTO>> {
        return this._lookupClient.deliveryModes();
    }

    public ClaimStatusTypes(): Promise<Array<ClaimStatusTypeDTO>> {
        return this._lookupClient.claimStatusTypes();
    }

    public WarrantyClassCodes(): Promise<Array<WarrantyClassCodeDTO>> {
        return this._lookupClient.warrantyClassCodes();
    }
    public WarrantyRemedyCodes(): Promise<Array<WarrantyRemedyCodeDTO>> {
        return this._lookupClient.warrantyRemedyCodes();
    }
    public WarrantyFailureCodes(): Promise<Array<WarrantyFailureCodeDTO>> {
        return this._lookupClient.warrantyFailureCodes();
    }
    public WarrantyMiscChargeCodes(): Promise<Array<WarrantyMiscChargeCodeDTO>> {
        return this._lookupClient.warrantyMiscChargeCodes();
    }
    public ExportWarrantyClassCodes(): Promise<ExportDTO> {
        return this._lookupClient.exportWarrantyClassCodes();
    }
}